<template>
  <v-tabs v-if="$page.props.tabs" v-model="active">
    <v-tab v-for="tab in $page.props.tabs" :key="tab.label" @click="visit(tab)">
      {{ tab.label }}
    </v-tab>
  </v-tabs>
</template>
<script>
export default {
   data: () => ({
      active: null,
   }),
   watch: {
      '$page.props.tabs': function () {
         for (const key in this.$page.props.tabs) {
            if (!this.$page.props.tabs[key].route) {
               this.active = parseInt(key)
               return
            }
         }
      },
   },
   created () {
      for (const key in this.$page.props.tabs) {
         if (!this.$page.props.tabs[key].route) {
            this.active = parseInt(key)
            return
         }
      }
   },
   methods: {
      visit (tab) {
         if (tab.route) {
            this.$inertia.visit(tab.route)
         }
      },
   },
}
</script>
